import { render, staticRenderFns } from "./strumenti.html?vue&type=template&id=3e28262b&"
import script from "./Strumenti.vue?vue&type=script&lang=js&"
export * from "./Strumenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports